import { RdsDialogRef } from '@rds/angular-components';
import { POPUPS } from '../constants/popups.constants';

export function attachDirtyDialogGuard(dialogRef: RdsDialogRef<any>) {
  // Keep a reference to the original close function
  const originalClose = dialogRef.close.bind(dialogRef);

  // Helper helper to verify if the form is dirty and if the user wants to proceed
  const shouldAllowClose = (): boolean => {
    const instance: any = dialogRef.componentInstance;
    
    if (instance?.form?.dirty) {
      return window.confirm(POPUPS.UNSAVED_CONFIRMATION.CONFIRMATION_MESSAGE);
    }
    return true; // Form isn't dirty, safe to close
  };

  // Handle Backdrop Click
  dialogRef.backdropClick().subscribe(() => {
    if (shouldAllowClose()) {
      originalClose(false);
    }
  });

  // Intercept direct .close() calls (like your Cancel button)
  dialogRef.close = (result?: any) => {

    if (result === undefined || result === false) {
      if (!shouldAllowClose()) {
        return;
      }
    }
    
    // Proceed with the standard close execution path
    originalClose(result);
  };
}